import React, { useState } from 'react'
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { Link } from "react-router-dom";
import {
    getAdminUsers,
    getAdminUserById,
    deleteAdminUser
} from '../../../api/apiServices';
import Pagination from '../../../services/Pagination'
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import toast from 'react-hot-toast'

const Table1 = () => {
    const [user, setUser] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [postPerPage, setPostPerPage] = useState(10);
    const queryClient = useQueryClient();

    const {
        isLoading,
        isError,
        error,
        data: users,
    } = useQuery('users', getAdminUsers, {
        select: data => data.sort((a, b) => b.id - a.id)
    });


    const indexOfLastPage = currentPage * postPerPage;
    const indexOfFirstPage = indexOfLastPage - postPerPage;
    const currentPosts = users?.slice(indexOfFirstPage, indexOfLastPage);

    const viewUserMutation = useMutation(getAdminUserById, {
        onSuccess: async (res) => {
            setUser(res)
        },
        onError: async (err) => {
            toast.error(err, {
                duration: 3000,
            })
        }
    })

    const deleteAdminUserMutation = useMutation(deleteAdminUser, {
        onSuccess: async (res) => {
            // Invalidate cached data
            toast.success(res.message, {
                duration: 3000,
            })
            queryClient.invalidateQueries("users")
        },
        onError: async (err) => {
            toast.error(err.message, {
                duration: 3000,
            })
        }
    })

    const handleAdd = () => { }

    const handleConfirm = (id) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='confirm-container'>
                        <h3><i className='fa fa-warning'></i> Confirm Deletion</h3>
                        <p>Are you sure you want to delete the user?</p>
                        <br />
                        <div className='confirm-buttons'>
                            <button
                                className="btn btn-danger"
                                onClick={onClose}
                            >
                                No
                            </button>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <button
                                className="btn btn-success"
                                onClick={() => { deleteAdminUserMutation.mutate(id); onClose(); }}
                            >
                                Yes
                            </button>
                        </div>
                    </div>
                );
            }
        });
    }

    const handleCancel = () => {
        setUser([])
    }

    const handleView = (id) => {
        viewUserMutation.mutate(id);
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <>
                        <div className="panel panel-info">
                            <div className="panel-heading">
                                User Details
                            </div>
                            <div className="panel-body">
                                {contentView}
                            </div>
                            <div className="panel-footer">
                                <div style={{
                                    display: "flex", alignItems: "center",
                                    justifyContent: "center"
                                }}>
                                    <button className="btn btn-danger" onClick={() => { handleCancel(); onClose(); }} >Exit</button>
                                   
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                </div>
                            </div>
                        </div>
                    </>
                );
            }
        });

    }

    const handleEdit = (id) => {
    }

    let content
    if (isLoading) {
        content = <p>Loading...</p>
    } else if (isError) {
        content = <p>{error.message}</p>
    } else {
        content =
            <>
                <div className="table-responsive lg">
                    <table className="table table-sm table-borderless table-hover table-striped">
                        <thead>
                            <tr>
                                <th style={{ textAlign: 'center' }}>#</th>
                                <th>User ID</th>
                                <th>Username</th>
                                <th>Full Name</th>
                                <th>Role</th>
                                <th>Email</th>
                                <th>Mobile Number</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentPosts.map((item, index) =>
                                <tr key={item.id}>
                                    <td>{postPerPage * (currentPage - 1) + index + 1}</td>
                                    <td style={{ whiteSpace: 'nowrap' }}>{item.id}</td>
                                    <td style={{ whiteSpace: 'nowrap' }}>{item.username}</td>
                                    <td style={{ whiteSpace: 'nowrap' }}>{item.first_name + " " + item.middle_name + " " + item.last_name}</td>
                                    {item.role_id === 4000
                                        ?
                                        <td style={{ whiteSpace: 'nowrap' }}>USER</td>
                                        : item.role_id === 3000
                                            ?
                                            <td style={{ whiteSpace: 'nowrap' }}>SUPER USER</td>
                                            : item.role_id === 1000
                                                ?
                                                <td style={{ whiteSpace: 'nowrap' }}>SUPER ADMIN</td>
                                                : <td></td>
                                    }
                                    <td style={{ whiteSpace: 'nowrap' }}>{item.email}</td>
                                    <td style={{ whiteSpace: 'nowrap' }}>{item.mobile_number}</td>
                                    <td style={{ whiteSpace: 'nowrap' }}>
                                        <div style={{ display: 'inline-block' }}>
                                            <Link onClick={() => handleView(item.id)} className="small"><i className='fa fa-eye'></i> view</Link>
                                        </div>&nbsp; &nbsp;
                                        <div style={{ display: 'inline-block', whiteSpace: 'nowrap' }}>
                                            <Link onClick={() => handleEdit(item.id)} className="small mr-3">
                                                <i className='fa fa-edit'></i> edit
                                            </Link>
                                        </div>
                                        &nbsp;&nbsp;
                                        <div style={{ display: 'inline-block' }}>
                                            <Link className="small" onClick={() => handleConfirm(item.id)}><i className='fa fa-trash'></i> delete</Link>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </>
    }

    let contentView
    if (user) {
        console.log("contentView ", user)
        contentView =(
            <>
                <div className="view-container">
                    <table className="table table-borderless">
                        <tbody>
                            <tr>
                                <td colSpan="2">
                                    <label>Username</label>
                                    <abbr title="required">
                                    </abbr>
                                    <strong ></strong>
                                </td>
                                <td >
                                    <label align="left" readOnly type="text" name="" className="form-control" >{user?.username} </label>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="2">
                                    <label>First Name</label>
                                    <abbr title="required">
                                    </abbr>
                                    <strong ></strong>
                                </td>
                                <td >
                                    <label align="left" readOnly type="text" name="" className="form-control" >{user?.first_name} </label>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="2">
                                    <label>Middle Name</label>
                                    <abbr title="required">
                                    </abbr>
                                    <strong ></strong>
                                </td>
                                <td >
                                    <label align="" readOnly type="text" name="" className="form-control" >{user?.middle_name} </label>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="2">
                                    <label>Last Name</label>
                                    <abbr title="required">
                                    </abbr>
                                    <strong ></strong>
                                </td>
                                <td >
                                    <label align="left" readOnly type="text" name="" className="form-control" >{user?.last_name} </label>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="2">
                                    <label>Email</label>
                                    <abbr title="required">
                                    </abbr>
                                    <strong ></strong>
                                </td>
                                <td >
                                    <label align="left" readOnly type="text" name="" className="form-control" >{user?.email} </label>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="2">
                                    <label>Mobile Number</label>
                                    <abbr title="required">
                                    </abbr>
                                    <strong ></strong>
                                </td>
                                <td >
                                    <label align="left" readOnly type="text" name="" className="form-control" >{user?.mobile_number} </label>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="2">
                                    <label>Role</label>
                                    <abbr title="required">
                                    </abbr>
                                    <strong ></strong>
                                </td>
                                <td >
                                    <label align="left" readOnly type="text" name="" className="form-control" >{user?.role_id} </label>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="2">
                                    <label>Date Created</label>
                                    <abbr title="required">
                                    </abbr>
                                    <strong ></strong>
                                </td>
                                <td >
                                    <label align="left" readOnly type="text" name="" className="form-control" >{user?.createdAt} </label>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
            </>
        )
    }

    return (
        <>
            <section className="content-header">
                <h1>Table Style</h1>
            </section>

            <section className="content">
                <div className="box">
                    <div className="box-body">

                        <div className="panel panel-info panel-br-4">
                            <div className="panel-heading">
                                <div className="row">
                                    <div className="col-sm-6">
                                        <h4 className="panel-title">
                                            <i className="fa fa-file-text" aria-hidden="true"></i>
                                            <span>Documents</span>
                                        </h4>
                                    </div>
                                    <div className="col-sm-3" style={{ display: "flex" }}>
                                        <button className="btn btn-warning mr-10">
                                            <span>Save new order</span>
                                        </button>
                                        <button className="btn btn-warning">
                                            <i className="fa fa-chevron-circle-down" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                    <div className="col-sm-3">
                                        <a id="document-сreate-btn" className="btn btn-success mr-10" data-url="">
                                            <i className="fa fa-plus-circle"></i>
                                            <span>Create new document</span>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div className="panel-body">
                                <Link id="document-сreate-btn" className="btn btn-success mr-10" onClick={handleAdd}>
                                    <i className="fa fa-plus-circle"></i> Add User
                                </Link>
                                <br /><br />
                            </div>
                            {content}
                            <div className="panel-footer">
                                <Pagination
                                    data={users ? users : {}}
                                    postPerPage={postPerPage}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                    setPostPerPage={setPostPerPage}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="box-footer"></div>
                </div >
            </section >
        </>
    )
}

export default Table1





